import { render, staticRenderFns } from "./RelatedModelField.vue?vue&type=template&id=5dc9a1b0&"
import script from "./RelatedModelField.vue?vue&type=script&lang=ts&"
export * from "./RelatedModelField.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports